import { call, select } from "typed-redux-saga";
import generateCategoricalScores from "./saga-functions/generate-categorical-scores";
import generateCorrelations from "./saga-functions/generate-correlations";
import { selectLeftPanelState } from "../selectors";
import { isColumnCategorical } from "../selectors/root.selector";
import { TRootState } from "../store/create-store";

function* generateScoresSaga() {
  const { selectedColumn } = yield* select(selectLeftPanelState);

  if (!selectedColumn) {
    return;
  }

  const isCategorical = yield* select((state: TRootState) =>
    isColumnCategorical(state, selectedColumn)
  );

  if (!isCategorical) {
    yield* call(generateCorrelations);
  } else {
    yield* call(generateCategoricalScores);
  }
}

export default generateScoresSaga;
